<template>
  <div class="doctor-salary-page">
    <el-form class="search-form" :model="searchForm" inline size="small">
      <el-form-item label="账单月份">
        <el-date-picker v-model="searchForm.condition.salaryMonth" type="month" value-format="yyyy-MM" format="yyyy-MM"
          placeholder="请选择月份" clearable />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table class="salary-table" :data="tableData" border height="560" :cell-style="{ borderColor: '#dcdfe6' }"
      :header-cell-style="{ background: '#f5f7fa', borderColor: '#dcdfe6', color: '#333333' }">
      <el-table-column prop="salaryMonth" label="月份" width="100" fixed="left" />
      <el-table-column prop="payableSalaryAmount" label="应发工资" width="120" align="right" />
      <el-table-column prop="registerCommissionAmount" label="挂号费" width="120" align="right" />
      <el-table-column prop="processCommissionAmount" label="加工费" width="120" align="right" />
      <el-table-column prop="clinicHerbCommissionAmount" label="门诊饮片" width="120" align="right" />
      <el-table-column prop="clinicGranuleCommissionAmount" label="门诊颗粒" width="120" align="right" />
      <el-table-column prop="onlineHerbCommissionAmount" label="网诊饮片" width="120" align="right" />
      <el-table-column prop="onlineGranuleCommissionAmount" label="网诊颗粒" width="120" align="right" />
      <el-table-column prop="physioOrderCommissionAmount" label="理疗开单" width="120" align="right" />
      <el-table-column prop="physioExecuteCommissionAmount" label="理疗执行" width="120" align="right" />
      <el-table-column prop="retailCommissionAmount" label="零售" width="110" align="right" />
      <el-table-column prop="certificateSubsidyAmount" label="证书补贴" width="120" align="right" />
      <el-table-column prop="trafficSubsidyAmount" label="交通补贴" width="120" align="right" />
      <el-table-column prop="otherFixedSubsidyAmount" label="其它固定补贴" width="140" align="right" />
      <el-table-column prop="notReachedGuaranteeCount" label="未达保底工资人数" width="160" align="right" />
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <!-- <el-button size="mini" @click="openImportDialog(scope.row)">导入线下数据</el-button> -->
          <!-- <el-button size="mini" @click="openImportDialog(scope.row)">查看线下数据</el-button> -->
          <el-button size="mini" @click="handleViewBill(scope.row)">查看明细</el-button>
          <el-button v-if="scope.row.salaryMonth == $moment().subtract(1, 'month').format('YYYY-MM')" size="mini" @click="handleGenerate(scope.row)">重新生成</el-button>
          <!-- <el-button size="mini" @click="handleGenerate(scope.row)">下载账单</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <div class="page-wrap">
      <el-pagination background layout="sizes,total, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 40]"
        :page-size="searchForm.pageSize" :current-page="searchForm.pageIndex" :total="total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { salaryBillPage,salaryBillGenerate } from '@/api/salary';

export default {
  name: 'DoctorSalary',
  data() {
    return {
      total: 2,
      searchForm: {
        condition: {
          salaryMonth: '',
        },
        pageIndex: 1,
        pageSize: 10
      },
      tableData: []
    };
  },
  mounted() {
    this.getSalaryList();
  },
  methods: {
    handleSearch() {
      this.searchForm.pageIndex = 1;
      this.getSalaryList();
    },
    handleReset() {
      this.searchForm = {
        condition: {
          salaryMonth: '',
        },
        pageIndex: 1,
        pageSize: 10
      };
      this.getSalaryList();
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.searchForm.pageIndex = 1;
      this.getSalaryList();
    },
    handleCurrentChange(pageIndex) {
      this.searchForm.pageIndex = pageIndex;
      this.getSalaryList();
    },
    openImportDialog(row) {
      this.$router.push({
        path: '/salary/importOfflineData',
        query: { salaryMonth: row.salaryMonth }
      });
    },
    handleGenerate(row) {
      this.$confirm(`因数据量过大，将在凌晨开始执行重新生成任务`, '提示', {
        confirmButtonText: '确定重新生成',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        salaryBillGenerate(row.salaryMonth).then(res => {
          if (res.code === 200) {
            this.$message.success('重新生成任务已提交，将在凌晨开始执行');
          }
        })
      }).catch(() => { });
    },
    handleViewBill(row) {
      this.$router.push({
        path: '/salary/doctorSalaryBill',
        query: { salaryMonth: row.salaryMonth }
      });
    },
    getSalaryList() {
      salaryBillPage(this.searchForm).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.doctor-salary-page {
  padding: 16px;
  background: #ffffff;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .search-form {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-bottom: 12px;

    /deep/ .el-form-item {
      margin-bottom: 12px;
    }
  }

  .salary-table {
    width: 100%;
  }

  .page-wrap {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
  }

  /deep/ .el-date-editor {
    width: 180px;
  }
}
</style>